import type { FC } from "react";
import React from "react";

import clsx from "clsx";

import LoaderIcon from "assets/icons/animated/loader.svg?react";

interface LoaderProps {
	wrapper?: boolean;
	wrapperClassName?: string;
	className?: string;
}

const Loader: FC<LoaderProps> = ({ wrapper, wrapperClassName, className }) => {
	if (wrapper) {
		return (
			<div className={clsx("w-full h-full flex items-center justify-center min-h-[100px]", wrapperClassName)}>
				<LoaderIcon className={clsx("w-12 h-12", className)} />
			</div>
		);
	}

	return <LoaderIcon className={clsx("w-12 h-12", className)} />;
};

export default Loader;
